import request from '@/utils/infrastructure/communication/request';

const controller = new AbortController();
const { signal } = controller;

export async function sendProcessForm({ processId, formId, data = {}, reCaptchaToken }) {
  return request.post(`/processEngine/start/${processId}/${formId}`, {
    headers: {
      'Content-Type': 'application/json',
      'reCaptcha-Token': reCaptchaToken,
    },
    data,
  });
}

export async function authProcess({ type, ...data }) {
  return request.post(`/auth/${type}Process`, {
    signal,
    credentials: 'include',
    data,
  });
}

export async function getProcessConfig(id) {
  return request(`/processEngine/start/${id}`);
}

export async function externalHandle({ code, token }) {
  return request(`/external/handle/${code}`, {
    headers: {
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    },
  });
}
